import * as React from 'react'

export function InterestingDivider() {
  return (
    <div style={{margin: '30px 10px', height: 5, overflow: 'hidden'}}>
      <hr style={{margin: 0, border: '25px dashed grey'}}/>
    </div>
  )
}
